"use client";

import { cn } from "@/lib/utils/general-utils";
import type { ReactNode } from "react";

export interface AvailableFilter {
  id: string;
  label: string;
  component: ReactNode;
}

export interface TableFilterBarProps {
  readonly filters: AvailableFilter[];
  readonly className?: string;
}

export function TableFilterBar({
  filters,
  className,
}: Readonly<TableFilterBarProps>) {
  if (filters.length === 0) return null;

  return (
    <div
      className={cn("flex flex-wrap items-center gap-2 pb-2", className)}
      data-tour="filter-controls"
    >
      {filters.map((filter) => (
        <div key={filter.id} data-filter-item className="shrink-0">
          {filter.component}
        </div>
      ))}
    </div>
  );
}
